import axios from "axios";
const api = axios.create({
  baseURL: process.env.REACT_APP_RAF_INSTANCE,
});
export const url = process.env.REACT_APP_RAF_INSTANCE;

export default api;
